'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Badge = function (_React$Component) {
	_inherits(Badge, _React$Component);

	function Badge() {
		_classCallCheck(this, Badge);

		return _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
	}

	_createClass(Badge, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    className = _props.className,
			    props = _objectWithoutProperties(_props, ['className']);

			return _react2.default.createElement(_reactBootstrap.Badge, _extends({
				className: (0, _classnames2.default)('axui', className)
			}, props));
		}
	}]);

	return Badge;
}(_react2.default.Component);

Badge.propTypes = {
	/**
  * The class name to apply to the badge.
  */
	className: _propTypes2.default.string,

	/**
  * Right-aligns the badge
  */
	pullRight: _propTypes2.default.bool,

	/**
  * The colour of the badge.
  * Neutral is the previous default gray badge color
  */

	bsStyle: _propTypes2.default.oneOf(['success', 'info', 'warning', 'danger', 'neutral'])
};

Badge.defaultProps = {
	bsStyle: 'info'
};

var _default = Badge;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Badge, 'Badge', 'src/components/Badge.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/Badge.jsx');
}();

;